/** Deep Research panel strings (extracted to keep en.ts under the size ratchet). */
export const enDeepResearchPanel = {
	noProspectTitle: "No Lead Added",
	noProspectDescription: "Deep Research can only be done for a person at a company.",
	copy: "Copy Deep Research",
	copied: "Copied",
	emptyTitle: "Deep Research",
	emptyDescription:
		"Run AI-powered deep research to gather comprehensive insights about this lead and their company.",
	run: "Run Deep Research",
	inProgressTitle: "Research in Progress",
	inProgressDescription: "Deep research is being generated. This may take a moment...",
	// Queued, running and failed runs (PREC-4052).
	queuedTitle: "Queued · {{elapsed}}",
	queuedDescription: "Waiting for a free slot. The research starts as soon as one opens.",
	runningTitle: "Researching… · {{elapsed}}",
	slowQueued: "Taking longer than usual: still waiting for a free slot.",
	slowRunning: "Taking longer than usual: still researching.",
	failed: "The last research could not be completed.",
	failedCredits:
		"Not enough credits for Deep Research. Add credits under Company Settings → Plans & Billing.",
	tryAgain: "Try again",
	dismiss: "Dismiss",
	chipQueued: "Deep research queued",
	chipFailed: "Deep research failed. Open the lead to try again.",
	usingTemplate: "Using template:",
	editTemplate: "Edit prompt template →",
	rerun: "Re-run Deep Research",
	rerunTitle: "Re-run deep research",
	rerunDescription: "This replaces the current research for this lead.",
	rerunDescriptionWithTemplates:
		"Select the template to run. This replaces the current research for this lead.",
	currentTemplate: "Current",
	credits_one: "{{count}} credit",
	credits_other: "{{count}} credits",
	lastResearchedAt: "Last research: {{date}}",
	researchedOn: "Researched on {{date}}",
	template: "Deep Research Template",
	expand: "Expand",
	collapse: "Collapse",
	source: "Source",
	sources: "Sources",
	noSourcesHint: "This research has no sources yet. Re-run it to add them.",
	pinForSequence: "Mention in sequence",
	pinnedForSequence: "In sequence",
	writeSequenceFromFact: "Write the sequence — opens the Chat tab with AI ready",
	unpinFromSequence: "Don't mention this fact",
	pinnedCount_one: "{{count}} fact will be mentioned in the next sequence",
	pinnedCount_other: "{{count}} facts will be mentioned in the next sequence",
	wordsSelected_one: "{{count}} word selected",
	wordsSelected_other: "{{count}} words selected",
	selectionLabel: "Selected from research",
};
